const AuthRoutes = [
  {
    path: "/login",
    name: "Login",
    meta: {
      requiresGuest: true,
    },
    component: () =>
      import(/* webpackChunkName: "AuthModule" */ "./pages/LoginPage.vue"),
  },
  {
    path: "/signup",
    name: "SignUp",
    meta: {
      requiresGuest: true,
    },
    component: () =>
      import(/* webpackChunkName: "AuthModule" */ "./pages/SignUpPage.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "AuthModule" */ "./pages/Logout.vue"),
  },
  {
    path: "/cli",
    name: "CLI",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "AuthModule" */ "./pages/CLIPage.vue"),
  }
];

export default AuthRoutes;
